import moment from 'moment';
import setStartEndOfDay from './setStartEndOfDay';

// Build the outbound range params for the Working-Time report:
// - default `to` to `from` (single day) when `to` is missing;
// - ensure from <= to (swap an inverted range so Apply can never send from > to);
// - drop the UI-only `filterType` (not a backend param);
// - normalize the bounds to start/end of day.
const normalizeWorkingTimeRange = (params: any) => {
  const { filterType, ...rest } = params;
  let { from, to } = rest;

  if (!to) {
    to = from;
  }
  if (from && to && moment(to).isBefore(moment(from))) {
    [from, to] = [to, from];
  }

  return setStartEndOfDay({ ...rest, from, to }, ['from', 'to']);
};

export default normalizeWorkingTimeRange;
